<template>
  <header class="nav-bar">
    <div class="nav-inner g-container">
      <div class="nav-left">
        <a class="brand" href="/" @click.prevent="go('/')">
          <img src="@/assets/logo-blue.svg" alt="电子保函" />
        </a>
        <nav class="nav-menu">
          <a
            v-for="m in menus"
            :key="m.path"
            :class="['nav-item', isActive(m.path) && 'is-active']"
            @click="go(m.path)"
          >
            {{ m.label }}
          </a>
        </nav>
      </div>

      <div class="nav-right">
        <template v-if="hasLogin">
          <div class="user-menu" @click.stop>
            <div class="user-trigger" @click="userOpen = !userOpen">
              <img class="avatar" src="@/assets/head.png" alt="" />
              <span class="user-name">{{ nickName }}</span>
              <i class="caret"></i>
            </div>
            <transition name="fade">
              <ul v-show="userOpen" class="user-dropdown" @click="userOpen = false">
                <li @click="go('/attestation?tab=basic')">
                  <i class="ico ico-account"></i>账号认证
                </li>
                <li @click="go('/attestation?tab=order')">
                  <i class="ico ico-order"></i>我的订单
                </li>
                <li @click="go('/attestation?tab=bill')">
                  <i class="ico ico-bill"></i>我的发票
                </li>
                <li class="divider"></li>
                <li class="danger" @click="loginOut">
                  <i class="ico ico-out"></i>退出登录
                </li>
              </ul>
            </transition>
          </div>
        </template>
        <template v-else>
          <!-- 桌面端：双按钮 -->
          <div class="auth-pc">
            <button class="g-btn g-btn-default" @click="goAuth('login')">登录</button>
            <button class="g-btn g-btn-primary" @click="goAuth('register')">免费注册</button>
          </div>
          <!-- 移动端：单个图标 -->
          <button class="auth-mobile" @click="goAuth('login')" aria-label="登录">
            <i class="el-icon-user-solid"></i>
          </button>
        </template>

        <!-- 移动端汉堡菜单 -->
        <button
          class="hamburger"
          :class="mobileOpen && 'is-open'"
          @click.stop="mobileOpen = !mobileOpen"
          aria-label="菜单"
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>

    <!-- 移动端展开菜单 -->
    <transition name="drawer">
      <div v-show="mobileOpen" class="mobile-drawer" @click="mobileOpen = false">
        <ul class="mobile-menu" @click.stop>
          <li
            v-for="m in menus"
            :key="m.path"
            :class="['mobile-item', isActive(m.path) && 'is-active']"
            @click="go(m.path)"
          >{{ m.label }}</li>
          <li class="mobile-divider"></li>
          <li @click="goAuth('login')">登录</li>
          <li class="mobile-item-primary" @click="goAuth('register')">免费注册</li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<script>
import { logout } from '@/lib/api/login'

export default {
  name: 'NavBar',
  data () {
    return {
      hasLogin: false,
      nickName: '',
      userOpen: false,
      mobileOpen: false,
      menus: [
        { label: '首页', path: '/' },
        { label: '项目标段', path: '/project' },
        { label: '产品服务', path: '/product' },
        { label: '帮助中心', path: '/help' },
        { label: '保函真伪查询', path: '/search' }
      ]
    }
  },
  watch: {
    $route () {
      this.refreshAuth()
      this.mobileOpen = false
    }
  },
  created () {
    this.refreshAuth()
    document.addEventListener('click', this.handleDocClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocClick)
  },
  methods: {
    refreshAuth () {
      this.hasLogin = !!localStorage.getItem('token')
      this.nickName = localStorage.getItem('nickName') || ''
    },
    handleDocClick () { this.userOpen = false },
    isActive (path) {
      if (path === '/') return this.$route.path === '/'
      return this.$route.path.indexOf(path) === 0
    },
    go (path) {
      // 跳转路由前关掉用户下拉
      this.userOpen = false
      if (this.$route.path !== path && this.$route.fullPath !== path) {
        this.$router.push(path)
      }
    },
    /**
     * 点击"登录 / 免费注册"按钮：跳转独立 /login 路由，附带 mode 与 redirect 参数
     * 兼容旧页面下发 open-auth 事件（不再依赖监听）
     */
    goAuth (mode) {
      this.userOpen = false
      // 已在 /login 时不重复跳转，仅切换 mode
      if (this.$route.path === '/login') {
        this.$router.replace({ path: '/login', query: { ...this.$route.query, mode } })
      } else {
        const redirect = (this.$route.path && this.$route.path !== '/login') ? this.$route.fullPath : '/'
        this.$router.push({ path: '/login', query: { mode, redirect } })
      }
    },
    async loginOut () {
      const token = localStorage.getItem('token')
      try { await logout(token) } catch (e) { /* ignore */ }
      localStorage.removeItem('token')
      localStorage.removeItem('deptId')
      localStorage.removeItem('nickName')
      localStorage.removeItem('userId')
      this.hasLogin = false
      this.nickName = ''
      this.$store.commit('login', '')
      this.$store.commit('isCheck', null)
      this.$message.success('已退出登录')
      if (this.$route.path !== '/') this.$router.replace('/')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.nav-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid @border-light;
  backdrop-filter: saturate(180%) blur(8px);
}

.nav-inner {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 48px;
  min-width: 0;
  flex: 1;
}

.brand img {
  height: 36px;
  display: block;
  flex-shrink: 0;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav-item {
  position: relative;
  font-size: @font-md;
  color: @text-secondary;
  font-weight: @font-weight-medium;
  cursor: pointer;
  padding: 8px 0;
  transition: color @duration-fast @ease-out;

  &:hover { color: @primary; }
  &.is-active {
    color: @primary;
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      width: 24px;
      height: 3px;
      border-radius: 3px;
      background: @primary;
    }
  }
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.auth-pc {
  display: flex;
  align-items: center;
  gap: 12px; /* 登录 / 免费注册 两个按钮之间的间距 */

  .g-btn {
    min-width: 88px; /* 保证两个按钮等宽，视觉更整齐 */
  }
}

/* ============ 移动端样式 ============ */
@media (max-width: 900px) {
  .nav-inner { height: 56px; }
  .brand img { height: 28px; }

  .nav-left { gap: 0; }

  .nav-menu,
  .auth-pc { display: none !important; }

  .auth-mobile {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: @primary-soft;
    color: @primary;
    border: none;
    cursor: pointer;
    font-size: 18px;
    margin-right: 4px;
  }

  .hamburger {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    width: 36px;
    height: 36px;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: @radius-sm;
    transition: background @duration-fast @ease-out;

    &:hover { background: @bg-soft; }

    span {
      display: block;
      width: 18px;
      height: 2px;
      background: @text-base;
      margin: 0 auto;
      border-radius: 2px;
      transition: transform @duration-base @ease-out, opacity @duration-fast @ease-out;
    }

    &.is-open {
      span:nth-child(1) { transform: translateY(6px) rotate(45deg); }
      span:nth-child(2) { opacity: 0; }
      span:nth-child(3) { transform: translateY(-6px) rotate(-45deg); }
    }
  }

  .mobile-drawer {
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, .45);
    z-index: 99;

    .mobile-menu {
      list-style: none;
      margin: 0;
      padding: 8px 0;
      background: #fff;
      box-shadow: @shadow-md;

      li {
        padding: 14px 20px;
        font-size: 15px;
        color: @text-base;
        cursor: pointer;
        transition: background @duration-fast @ease-out;
        border-bottom: 1px solid @border-light;

        &:last-child { border-bottom: none; }
        &:hover { background: @bg-soft; }

        &.is-active { color: @primary; font-weight: 600; }
        &.mobile-item-primary {
          color: #fff;
          background: @primary;
          font-weight: 600;

          &:hover { background: @primary-hover; }
        }
      }

      .mobile-divider {
        height: 8px;
        padding: 0;
        background: @bg-soft;
        border-bottom: none;
      }
    }
  }

  .drawer-enter-active, .drawer-leave-active {
    transition: opacity @duration-base @ease-out;
    .mobile-menu { transition: transform @duration-base @ease-out; }
  }
  .drawer-enter, .drawer-leave-to {
    opacity: 0;
    .mobile-menu { transform: translateY(-12px); }
  }
}

/* 桌面端：默认汉汉堡/移动菜单隐藏 */
@media (min-width: 901px) {
  .hamburger, .auth-mobile, .mobile-drawer { display: none !important; }
}

.user-menu { position: relative; }

.user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: @radius-full;
  cursor: pointer;
  transition: background @duration-fast @ease-out;

  &:hover { background: @bg-soft; }

  .avatar {
    width: 28px; height: 28px;
    border-radius: 50%;
    background: @primary-soft;
  }

  .user-name {
    font-size: @font-base;
    color: @text-base;
  }

  .caret {
    width: 0; height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid @text-muted;
    margin-left: 4px;
  }
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 180px;
  background: #fff;
  border-radius: @radius-md;
  box-shadow: @shadow-lg;
  padding: 6px 0;
  list-style: none;
  margin: 0;

  li {
    padding: 10px 16px;
    font-size: @font-base;
    color: @text-base;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: background @duration-fast @ease-out;

    &:hover { background: @bg-soft; }

    .ico {
      width: 16px; height: 16px;
      background: @primary;
      border-radius: 4px;
      display: inline-block;
      mask-position: center;
      mask-repeat: no-repeat;
      mask-size: contain;
    }
    &.danger { color: @danger; .ico { background: @danger; } }
    &.divider {
      padding: 0;
      height: 1px;
      background: @border-light;
      margin: 6px 0;
      cursor: default;
    }
  }
}

.fade-enter-active, .fade-leave-active { transition: opacity @duration-fast @ease-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
